import { useTranslation } from 'react-i18next';
import { RUTA_IMATGES, rutaPagina } from '../Compartido/contenidoCamprodon.js';
import CabeceraSeccion from './CabeceraSeccion.jsx';

const IMATGES = ["oferta-2-noches"];

const Ofertas = ({ textos, lang }) => {

    const { t } = useTranslation();

    return (
        <section className="offers o-container">
            <CabeceraSeccion {...textos.ofertas} boton={{ href: rutaPagina("ofertas", lang), label: t("Ver todo") }} />
            <div className="c-cards-list">
                {textos.ofertas.items.map((oferta, index) => (
                    <article className="c-card c-card--with-price" key={index}>
                        <div className="c-card__header">
                            <picture>
                                <source srcSet={RUTA_IMATGES + IMATGES[index] + ".webp"} type="image/webp" />
                                <img src={RUTA_IMATGES + IMATGES[index] + ".jpg"} alt={oferta.alt} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                            </picture>
                        </div>
                        <div className="c-card__body">
                            <div className="c-card__content">
                                <h3 className="c-card__title">{oferta.titulo}</h3>
                                {oferta.texto && <p>{oferta.texto}</p>}
                            </div>
                            <div className="c-card__footer">
                                <a href={rutaPagina("oferta-2-noches", lang)} className="c-link">{t("Descubrir")}</a>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
};

export default Ofertas;
